import React from 'react';
import RegisterForm from '../../components/Authentication/Register';

const RegisterPage: React.FC = () => {
  return (
    <>
      <RegisterForm />
    </>
  );
};

export default RegisterPage;
